import React, { useEffect } from 'react';
import { urlGenerator } from '../../../../utilities/order/urlGenerator';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { useUpdateOrderTimberHook } from 'API/order/useUpdateOrderHook';
import { EditPropertyAddressController } from '../../../../ui-toolkit/orders/components/EditPropertyAddress/EditPropertyAddressController';
import { IPropertyAddress } from '../../../../ui-toolkit/orders/interfaces/IPropertyAddress';

export interface IEditPropertyContainerProps {
  onClose?: () => void;
}

export const EditPropertyContainer: React.FC<IEditPropertyContainerProps> = (props) => {
  const { data: order } = useSelectCurrentOrder();
  const { action: doOrderUpdate } = useUpdateOrderTimberHook();
  const doSubmit = async (propertyAddress: IPropertyAddress, skipAddressValidation: boolean) => {
    await doOrderUpdate(
      order,
      {
        propertyAddress: {
          city: propertyAddress.city!,
          stateAbbreviation: propertyAddress.state!,
          streetAddress: propertyAddress.street_address!,
          unit: propertyAddress.unit,
          zipCode: propertyAddress.zip_code!,
        },
      },
      skipAddressValidation
    );
    return { message: '' };
  };

  // When they send in an onClose, they are also handling the document title.
  let onClose =
    props.onClose || (() => (window.location.href = urlGenerator.urlFor.orderStatus(order.transaction.id!)));

  useEffect(() => {
    if (props.onClose === undefined) {
      document.title = `Property Information: ${order.transaction.file_number}  - Spruce`;
    }
  }, [props.onClose, order.transaction.file_number]);

  return <EditPropertyAddressController actions={{ onClose, doSubmit }} propertyAddress={order.property} />;
};
